import styled, { css } from 'styled-components';
import { defaultTheme } from '@styles/theme.styled';

interface StyledSVGProps {
  color?: keyof typeof defaultTheme.colors;
  fill?: keyof typeof defaultTheme.colors;
}

export const StyledSVG = styled.svg<StyledSVGProps>`
  ${({ theme, color, fill }) => `
    stroke-width: ${theme.borderWidths.icons};
    stroke: ${color ? theme.colors[color] : 'none'};
    fill: ${fill ? theme.colors[fill] : 'none'};
`}
`;

export const StyledHeaderBackground = styled.svg`
  ${({ theme }) => css`
    position: absolute;
    bottom: -2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 3440px;
    height: 1440px;
    z-index: 1;

    @media only screen and (max-width: ${theme.breakpoints.md}) {
      transform: translateX(-50%) scale(0.5);
      transform-origin: 50% 100%;
    }
  `}
`;

interface StyledActionArrowProps {
  fillColor: keyof typeof defaultTheme.colors;
  strokeColor: keyof typeof defaultTheme.colors;
}

export const StyledActionArrow = styled.svg<StyledActionArrowProps>`
  ${({ theme, fillColor, strokeColor }) => css`
    stroke-width: ${theme.borderWidths.icons};

    .action-arrow-stroke {
      stroke: ${theme.colors[strokeColor]};
    }

    .action-arrow-fill {
      fill: ${theme.colors[fillColor]};
    }
  `}
`;
